export const isProspectFindWorkPage = () => window.location.href.indexOf("/find-work/") > -1;
export const isProspectDashboardPage = () => window.location.href.indexOf("/p/") > -1;